module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-SemiBold.7bd303c.eot";